<div class="posr">
  <mat-icon class="pointer" (click)="close()" i18n>close</mat-icon>
</div>
<pre class="p16">
   {{ data | json }}
</pre>


